import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppToasterContext } from 'components/shared/app-toaster/app-toaster-context';
import {
    buildOrderPdfFileName,
    downloadOrderPdf,
} from 'components/order-details/main-order-view/document-print-actions/files';
import { Order } from 'models/order';

/** Kept across logout (see utils/logout.ts) so the technician's choice is remembered. */
export const DOWNLOAD_WORKSHEET_STORAGE_KEY = 'receivedByLabDownloadWorksheet';
const WORKSHEET_PDF_TYPE = 'WORK_SHEET_V2_PDF';
const WORKSHEET_FILE_NAME_SUFFIX = '_work.pdf';

export const useReceivedByLabWorksheet = () => {
    const { t: translate } = useTranslation(['orders']);
    const { setAppToasterContent } = useContext(AppToasterContext);
    const [isWorksheetChecked, setIsWorksheetChecked] = useState<boolean>(
        () => localStorage.getItem(DOWNLOAD_WORKSHEET_STORAGE_KEY) === 'true',
    );

    const changeWorksheetChecked = (isChecked: boolean) => {
        setIsWorksheetChecked(isChecked);
        localStorage.setItem(DOWNLOAD_WORKSHEET_STORAGE_KEY, String(isChecked));
    };

    // Runs after the order is already received: a failed download must not undo that, so the
    // failure is shown to the technician instead of being rethrown.
    const downloadWorksheet = async (order: Order): Promise<void> => {
        try {
            const fileName = buildOrderPdfFileName(order, WORKSHEET_FILE_NAME_SUFFIX);
            await downloadOrderPdf(order._id, WORKSHEET_PDF_TYPE, fileName);
        } catch {
            setAppToasterContent({
                isOpen: true,
                severity: 'warning',
                message: translate('orders:ORDER_RECEIVED_WORKSHEET_DOWNLOAD_FAILED'),
            });
        }
    };

    return { isWorksheetChecked, changeWorksheetChecked, downloadWorksheet };
};
